import { createContext, Context } from 'react';
import { IconThemeContextValue } from './WixDesignSystemIconThemeProvider.types';

declare global {
  // Note: distinct from `@wix/wix-ui-icons-common`'s `__WDSIconThemeContext__`
  // (which holds an icon-theme string). This context holds WDS icon overrides.
  var __WDSSystemIconThemeContext__: Context<IconThemeContextValue> | undefined;
}

if (!globalThis.__WDSSystemIconThemeContext__) {
  globalThis.__WDSSystemIconThemeContext__ =
    createContext<IconThemeContextValue>({ icons: {} });
}

export const IconThemeContext = globalThis.__WDSSystemIconThemeContext__;
